/**
 * Timezone utilities for converting between UTC and broker timezone
 */

// Configure your broker's timezone offset here
// Common broker timezones:
// - GMT+2 (EET) / GMT+3 (EEST): European brokers
// - GMT+2: Most Forex brokers
// - GMT+5: Your current broker based on the example
export const BROKER_TIMEZONE_OFFSET = 5; // GMT+5 hours

/**
 * Formats timestamp to broker timezone in MT5 format
 * @param timestamp - Unix timestamp in seconds
 * @returns Formatted time string matching MT5 display
 */
export const formatBrokerTime = (timestamp: number): string => {
  // The timestamp from MT5 is already in broker time, just format it as UTC to avoid double conversion
  const date = new Date(timestamp * 1000);
  
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  
  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};

/**
 * Formats timestamp to broker timezone (short format)
 * @param timestamp - Unix timestamp in seconds  
 * @returns Short formatted time string
 */
export const formatBrokerTimeShort = (timestamp: number): string => {
  // The timestamp from MT5 is already in broker time, just format it as UTC to avoid double conversion
  const date = new Date(timestamp * 1000);
  
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  
  return `${year}.${month}.${day} ${hours}:${minutes}`;
};

/**
 * Gets the broker timezone name for display
 * @returns Timezone display string
 */
export const getBrokerTimezoneName = (): string => {
  const offset = BROKER_TIMEZONE_OFFSET;
  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset);
  return `GMT${sign}${absOffset}`;
};